import { render, staticRenderFns } from "./printreportcards.vue?vue&type=template&id=30352c15&"
import script from "./printreportcards.vue?vue&type=script&lang=js&"
export * from "./printreportcards.vue?vue&type=script&lang=js&"
import style0 from "./printreportcards.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports